import React from 'react'
import appStoreIcon from '../../assets/AppleStore.svg'
import playStoreIcon from '../../assets/GoogleStore.svg'
import newImageHomePage from '../../assets/newImageHomePage.svg'
import newImageHomePageMobile from '../../assets/newImageHomePageMobile.svg'
import { useTranslation } from 'react-i18next'

const ImageHomeContainer = () => {
  
const HandleClick=(url:string)=>{
  window.open(url, '_blank')
}
  const {t} = useTranslation()

  return (
    <div className='bg-[#E2E2FB] h-[230px] lg:h-[230px] sm:h-[120px]  w-full sm:px-[5px] px-[36px] 2xl:px-[14px]  rounded-[22px] flex justify-between  items-end '>
          <div className=' my-auto xl:pl-2 sm:w-[200px] '>
            <h1 className='font-bold text-[31px] 2xl:text-[28px] xl:text-[31px] sm:text-[18px] '>My Easy Transfer</h1>
            <h2 className='text-[#6A6888] text-[14px]   xl:w-full xl:text-[13px] sm:text-[8px] '>{t('ImageHomeContainer.sendMoneyTitle')} !</h2>
            <div className='flex gap-4 items-center mt-6 xl:mt-3'>
              <img className=' rounded-xl sm:w-[80px] lg:w-[130px] h-auto  cursor-pointer' width={130} height={60} src={appStoreIcon} alt='' onClick={()=>{HandleClick('https://apps.apple.com/ci/app/my-easy-transfer/id1572782943')}}/>
              <img  className='rounded-xl sm:w-[80px] lg:w-[130px] h-auto cursor-pointer' width={130} height={60}  src={playStoreIcon} alt='' onClick={()=>{HandleClick('https://play.google.com/store/apps/details?id=com.myeasytransfert&hl=en_US')}}/>
            </div>
          </div>
      <img 
        className='hidden sm:block '
          src={newImageHomePageMobile} width={127} height={188} alt='accuiel my easy Mobile'
      />
        <img  
        className='sm:hidden 2xl:w-[280px] lg:w-auto '
          src={newImageHomePage} width={312} height={263} alt='accuiel my easy Mobile'
          /> 
      
    </div>
    
  )
}

export default ImageHomeContainer
